import { useLang } from '../i18n/LanguageContext';
import { useCart } from '../context/CartContext';
import { formatVND, effectivePrice, pickLang } from '../lib/format';

// Shows current unlocked offer + progress toward the next tier,
// with cheap product suggestions to fill the gap (yêu cầu KH#6).
export default function OfferProgress({ tiers = [], products = [] }) {
  const { lang, t } = useLang();
  const { subtotal, add } = useCart();

  if (!tiers.length) return null;
  const sorted = [...tiers].sort((a, b) => a.min_subtotal - b.min_subtotal);
  const reached = sorted.filter((x) => subtotal >= Number(x.min_subtotal)).pop();
  const next = sorted.find((x) => subtotal < Number(x.min_subtotal));

  const gap = next ? Number(next.min_subtotal) - subtotal : 0;
  const pct = next ? Math.min(100, Math.round((subtotal / Number(next.min_subtotal)) * 100)) : 100;

  const suggestions = next
    ? products
        .filter((p) => effectivePrice(p) <= gap * 1.4)
        .sort((a, b) => effectivePrice(b) - effectivePrice(a))
        .slice(0, 3)
    : [];

  return (
    <div className="offer-box">
      {reached && (
        <div style={{ fontWeight: 600, color: 'var(--green)' }}>
          ✅ {t('offer.reached')} {pickLang(reached, 'reward', lang)}
        </div>
      )}
      {next && (
        <>
          <div style={{ fontWeight: 600 }}>
            🎯 {t('offer.next', { amount: formatVND(gap) })} <em>{pickLang(next, 'reward', lang)}</em>
          </div>
          <div className="progress"><div style={{ width: `${pct}%` }} /></div>
          {suggestions.length > 0 && (
            <div className="row" style={{ marginTop: 6 }}>
              <span className="muted">{t('offer.suggest')}</span>
              {suggestions.map((p) => (
                <button
                  key={p.id}
                  className="btn btn-secondary btn-sm"
                  onClick={() =>
                    add({ kind: 'product', id: p.id, name: p.name, name_en: p.name_en, price: effectivePrice(p), category: p.category })
                  }
                >
                  + {pickLang(p, 'name', lang)} · {formatVND(effectivePrice(p))}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
